var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "summary main" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.title))]),
      _c("omegaup-markdown", { attrs: { markdown: _vm.eventDescription } }),
      _vm.finishTime !== null
        ? _c(
            "table",
            { staticClass: "table table-bordered mx-auto w-50 mb-0" },
            [
              _vm.showDeadlines
                ? _c("tr", [
                    _c("td", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.T.arenaPracticeStartTime)),
                      ]),
                    ]),
                    _c("td", [
                      _vm._v(_vm._s(_vm.time.formatTimestamp(_vm.startTime))),
                    ]),
                  ])
                : _vm._e(),
              _vm.showDeadlines
                ? _c("tr", [
                    _c("td", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.T.arenaPracticeEndtime)),
                      ]),
                    ]),
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.finishTime
                              ? _vm.time.formatTimestamp(_vm.finishTime)
                              : _vm.T.wordsUnlimitedDuration
                          ) +
                          " "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.showRanking &&
              typeof _vm.scoreboard === "number" &&
              _vm.duration != Infinity
                ? _c("tr", [
                    _c("td", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.T.arenaPracticeScoreboardCutoff)),
                      ]),
                    ]),
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.time.formatTimestamp(
                              new Date(
                                _vm.startTime.getTime() +
                                  (_vm.duration * _vm.scoreboard) / 100
                              )
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("tr", [
                _c("td", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.T.arenaContestWindowLength)),
                  ]),
                ]),
                _c("td", [_vm._v(_vm._s(_vm.eventWindowLength))]),
              ]),
              _c("tr", [
                _c("td", [
                  _c("strong", [_vm._v(_vm._s(_vm.T.arenaContestOrganizer))]),
                ]),
                _c("td", [
                  _c("a", { attrs: { href: `/profile/${_vm.admin}/` } }, [
                    _vm._v(_vm._s(_vm.admin)),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.showLogs
        ? _c("div", { staticClass: "problem-change-log mt-3" }, [
            _c("h2", [_vm._v(_vm._s(_vm.T.arenaContestProblemChangeLog))]),
            _c(
              "table",
              { staticClass: "table table-bordered mx-auto w-50 mb-0" },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.T.wordsTime))]),
                    _c("th", [_vm._v(_vm._s(_vm.T.wordsActions))]),
                    _c("th", [_vm._v(_vm._s(_vm.T.wordsChangedBy))]),
                  ]),
                ]),
                _c(
                  "tbody",
                  [
                    _vm.logs.length === 0
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center text-muted",
                              attrs: { colspan: "3" },
                            },
                            [_vm._v(" " + _vm._s(_vm.T.wordsEmpty) + " ")]
                          ),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.logs, function (log, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.time.formatDateTime(log.timestamp))
                          ),
                        ]),
                        _c(
                          "td",
                          [
                            _c("omegaup-markdown", {
                              staticClass: "problem-change-log-message",
                              attrs: {
                                markdown: _vm.formatLogMessage(
                                  log.change_type,
                                  log.problemAlias
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                        _c("td", [_vm._v(_vm._s(log.changedBy))]),
                      ])
                    }),
                  ],
                  2
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }